"use client";
import Translation from "@workspace/casino_pages/legacyLayer/client/components/Translation";
import useRewardsNotificationStore from "@workspace/casino_pages/legacyLayer/legacy/client/components/Game/hooks/useNotificationStore";
import Button from "@workspace/casino_pages/legacyLayer/legacyUi/Button";
import Content from "@/server/components/NotificationWorker/NotificationWorkerHandler/showNotification/NotificationView/Content";
import useForfeitReward from "@/server/components/NotificationWorker/NotificationWorkerHandler/showNotification/NotificationView/FreebetRewardNotificationView/useForfeitReward";
import useSwitchCurrencyNotification from "@/server/components/NotificationWorker/NotificationWorkerHandler/showNotification/NotificationView/SwitchCurrencyNotification/hooks/useSwitchCurrencyNotification";

const FreebetRewardNotificationView: FC<NotificationViewProps> = (props) => {
  const { removeNotification } = useRewardsNotificationStore();
  const { onClose, context, notification } = props;
  const handleClose = () => {
    onClose();
    removeNotification("freeBetReward");
  };

  const { handleForfeit } = useForfeitReward({
    id: notification.data.rewardId,
    onClose: handleClose,
  });
  const { handleCurrencyChange } = useSwitchCurrencyNotification({
    ...props,
    onClose: handleClose,
  });

  return (
    <Content onClose={handleClose}>
      <div className="pt-8 grid gap-8">
        <h4 className="text-lg/6 text-black font-medium">
          {notification.data.title}
        </h4>
        <p className="text-muted-foreground text-sm/6">
          {notification.data.body}
        </p>
        <div className="grid gap-4 grid-flow-col grid-cols-[50%_50%]">
          {notification.data.isRequiredToSwitch ? (
            <Button onClick={handleForfeit} className="text-black bg-white">
              <Translation
                translations={context.translations}
                id="rewards.forfeit_reward"
              />
            </Button>
          ) : (
            <Button onClick={handleClose} className="text-black bg-white">
              <Translation
                translations={context.translations}
                id="general.no"
              />
            </Button>
          )}
          <Button variant="primary" onClick={handleCurrencyChange}>
            <Translation
              translations={context.translations}
              id="button.switch"
            />
          </Button>
        </div>
      </div>
    </Content>
  );
};
export default FreebetRewardNotificationView;
